<template>
  <div>
    <!-- 企业对公账户 -->
    <el-card class="box-card">
      <div style="font-size: 20px; font-weight: bold">企业对公账户</div>
      <div style="display: flex;align-items: center;">
        <div style="flex: 1;">
          <div class="account_info_row" style="margin-top: 15px">
            <span class="account_info_label">企业名称:</span>
            <span class="account_info_value">{{
              currentCompany.branchName || "--"
            }}</span>
          </div>
          <template>
            <!-- 账户余额 -->
            <div class="account_info_row" style="margin-top: 15px">
              <span class="account_info_label">账户余额(元):</span>
              <b class="highlight">{{
                showAmount
                  ? currentCompany.amount
                  : "*".repeat(
                      currentCompany.amount
                        ? currentCompany.amount.toString().length
                        : 6
                    )
              }}</b>
              <img
                v-if="!showAmount"
                class="psw_icon"
                src="@/assets/icon/pswhidden.png"
                alt=""
                @click="showAmount = !showAmount"
              />
              <img
                v-else
                class="psw_icon"
                src="@/assets/icon/pswshow.png"
                alt=""
                @click="showAmount = !showAmount"
              />
              <div v-if="typePane === 'current'">
                <!-- <span class="refresh_btn_text" @click="refreshCompany">刷新</span> -->
                <i
                  :class="loadingAmount ? 'el-icon-loading' : 'el-icon-refresh'"
                  class="refresh_icon"
                  @click="refreshCompany"
                />
              </div>
            </div>
            <!-- 待支付金额 -->
            <div
              v-if="isHasSub !== 1"
              class="account_info_row m_b_0"
              style="margin-top: 15px"
            >
              <span class="account_info_label">待支付金额(元):</span>
              <b class="highlight">{{
                showPending
                  ? noPayAmount
                  : "*".repeat(noPayAmount ? noPayAmount.toString().length : 6)
              }}</b>
              <img
                v-if="!showPending"
                class="psw_icon"
                src="@/assets/icon/pswhidden.png"
                alt=""
                @click="showPending = !showPending"
              />
              <img
                v-else
                class="psw_icon"
                src="@/assets/icon/pswshow.png"
                alt=""
                @click="showPending = !showPending"
              />
              <div v-if="typePane === 'current'">
                <!-- todo: -->
                <!-- <span class="refresh_btn_text" @click="refreshNoPay">刷新</span> -->
                <i class="el-icon-refresh refresh_icon" @click="refreshNoPay" />
              </div>
            </div>
          </template>
        </div>
        <!-- 支付宝白名单 -->
        <div
          v-if="isAlipay"
          style="flex: 1;border-left: 1px solid #ebeef5;padding-left: 20px;min-height:140px;"
        >
          <div class="account_info_row" style="margin-top: 15px">
            <span class="account_info_label">白名单账户:</span>
            <el-button
              round
              type="primary"
              size="mini"
              :loading="whitelistLoading"
              @click="handleQueryPayerWhitelist"
              >获取白名单</el-button
            >
          </div>
          <div v-if="whitelistNames.length" class="whitelist_list">
            <div
              v-for="(name, index) in whitelistNames"
              :key="index"
              class="whitelist_item"
            >
              {{ name }}
            </div>
          </div>
          <div v-else-if="whitelistQueried" class="whitelist_empty">
            暂无白名单数据
          </div>
        </div>
        <div
          v-if="isHasSub === 0"
          v-show="!isAlipay"
          style="flex: 1;border-left: 1px solid #ebeef5;padding-left: 20px;height:140px;"
        >
          <div class="account_info_row" style="margin-top: 15px">
            <span class="account_info_label"
              >可分配金额:
              <el-tooltip
                class="item"
                effect="dark"
                content="记账功能,公式为:可分配金额=账户余额+充值金额-已分配金额"
                placement="top-start"
              >
                <i class="el-icon-warning" />
              </el-tooltip>
            </span>
            <span
              style="font-size: 18px;color: #f56c6c;margin-right: 8px;font-weight: bold;"
              >￥{{ currentCompany.availableBalance }}</span
            >
            <el-button round @click="allocationAmountDialog = true"
              >资金分配</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
    <!-- 平台收款账户 -->
    <el-card class="box-card" style="margin-top:15px;margin-bottom:15px;">
      <div
        style="font-size: 20px; font-weight: bold;display:flex;align-items: center;"
      >
        <div>平台收款账户</div>
      </div>
      <template v-if="!isAlipay">
        <div class="account_info_row" style="margin-top: 15px">
          <span class="account_info_label">账户名称:</span>
          <span class="account_info_value">{{
            currentCompany.branchName || "--"
          }}</span>
          <span class="copy_text" @click="copyText(currentCompany.branchName)"
            >复制</span
          >
          <!-- <img
          @click="copyText(currentCompany.branchName)"
          style="width:25px;height:25px;"
          src="@/assets/icon/copy.png"
          alt=""
        /> -->
        </div>
        <div class="account_info_row">
          <span class="account_info_label">开户银行:</span>
          <span class="account_info_value">{{
            currentCompany.openingBank
          }}</span>
          <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.openingBank)"
                >复制</span
              > -->
          <!-- <img
          class="copy_text"
          @click="copyText(currentCompany.openingBank)"
          style="width:25px;height:25px;"
          src="@/assets/icon/copy.png"
          alt=""
        /> -->
          <span class="copy_text" @click="copyText(currentCompany.openingBank)"
            >复制</span
          >
        </div>
        <div class="account_info_row">
          <span class="account_info_label">银行账号:</span>
          <span class="account_info_value">{{
            currentCompany.bankAccount
          }}</span>
          <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.bankAccount)"
                >复制</span
              > -->
          <!-- <img
          class="copy_text"
          @click="copyText(currentCompany.bankAccount)"
          style="width:25px;height:25px;"
          src="@/assets/icon/copy.png"
          alt=""
        /> -->
          <span class="copy_text" @click="copyText(currentCompany.bankAccount)"
            >复制</span
          >
        </div>
        <!-- TODO: -->
        <div class="account_info_row">
          <span class="account_info_label">开户支行:</span>
          <span class="account_info_value">{{
            currentCompany.openingBranch
          }}</span>
          <span
            class="copy_text"
            @click="copyText(currentCompany.openingBranch)"
            >复制</span
          >
          <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.branchName)"
                >复制</span
              > -->
          <!-- <img
                class="copy_text"
                @click="copyText(currentCompany.branchName)"
                style="width:25px;height:25px;"
                src="@/assets/icon/copy.png"
                alt=""
              /> -->
        </div>
        <div class="account_info_row">
          <span class="account_info_label">银联号:</span>
          <span class="account_info_value">{{
            currentCompany.subBankAccount
          }}</span>
          <span
            class="copy_text"
            @click="copyText(currentCompany.subBankAccount)"
            >复制</span
          >
          <!-- <span
                class="copy_text"
                @click="copyText(currentCompany.subBankAccount)"
                >复制</span
              > -->
          <!-- <img
                class="copy_text"
                @click="copyText(currentCompany.subBankAccount)"
                style="width:25px;height:25px;"
                src="@/assets/icon/copy.png"
                alt=""
              /> -->
        </div>
        <el-button type="primary" size="mini" class="all_copy" @click="copyAll"
          >一键复制</el-button
        >
      </template>
      <template v-else>
        <div class="account_info_row" style="margin-top: 15px">
          <span class="account_info_label">账户名称:</span>
          <span class="account_info_value"
            >联帮帮物流科技(天津)有限责任公司</span
          >
          <span
            class="copy_text"
            @click="copyText('联帮帮物流科技(天津)有限责任公司')"
            >复制</span
          >
        </div>
        <div class="account_info_row">
          <span class="account_info_label">银行账号:</span>
          <span class="account_info_value">{{ alipayAccountNo || "--" }}</span>
          <span class="copy_text" @click="copyText(alipayAccountNo)">复制</span>
        </div>
        <div class="account_info_row">
          <span class="account_info_label">开户银行:</span>
          <span class="account_info_value">浙江网商银行</span>
          <span class="copy_text" @click="copyText('浙江网商银行')">复制</span>
        </div>
        <el-button
          type="primary"
          size="mini"
          class="all_copy"
          @click="copyAlipayAll"
          >一键复制</el-button
        >
      </template>

      <div class="tips_box">
        <div style="font-size: 15px; font-weight: bold;color:red;">
          *温馨提示：
        </div>
        <div class="m_r_20">
          1.请您务必使用贵司公户进行转账，否则无法开票;
        </div>
        <div class="m_r_20">
          2.线下转账一般为2小时内到账,如果长时间未到账,请联系客服处理;
        </div>
        <div class="m_r_20">
          3.请确认您要支付的运单所属承运主体是否和当前充值户名一致;
        </div>
        <div class="m_r_20">
          4.转账输入银行账号时不允许输入空格！并请仔细核对银行账号是否正确;
        </div>
        <div class="m_r_20">5.客服电话:{{ branch.telephone }};</div>
      </div>
    </el-card>
    <el-drawer
      title="资金分配"
      :visible.sync="allocationAmountDialog"
      size="40%"
    >
      <!-- currentCompany.availableBalance -->
      <fundAllocation
        v-if="allocationAmountDialog"
        :party-code="partyCode"
        :available-balance="currentCompany.availableBalance"
        @allocateSuccess="allocateSuccess"
      />
    </el-drawer>
  </div>
</template>
<script>
import FundAllocation from "./fundAllocation.vue";
import { queryPayerWhitelist } from "@/api/shipment";
import { mapState } from "vuex";
export default {
  name: "CardInfo",
  components: {
    FundAllocation
  },
  props: {
    isAlipay: {
      type: Boolean,
      default: false
    },
    partyCode: {
      type: String,
      default: ""
    },
    currentCompany: {
      type: Object,
      default: () => ({})
    },
    noPayAmount: {
      type: Number,
      default: 0
    },
    typePane: {
      type: String,
      default: ""
    },
    loadingAmount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isAdmin: false,
      isHasSub: this.$store.state.user.party.companyType,
      allocationAmountDialog: false,
      showAmount: false,
      showPending: false,
      whitelistLoading: false,
      whitelistQueried: false,
      whitelistNames: [],
      branch: {
        telephone: ""
      }
    };
  },

  computed: {
    ...mapState({
      shipment: state => state.user.shipment
    }),
    alipayAccountNo() {
      return (this.shipment && this.shipment.alipayAccount) || "";
    }
  },

  mounted() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    let info = JSON.parse(localStorage.getItem("dataBranch"));
    this.branch = info;
  },

  methods: {
    handleQueryPayerWhitelist() {
      if (!this.partyCode || this.whitelistLoading) return;
      this.whitelistLoading = true;
      queryPayerWhitelist({ code: this.partyCode })
        .then(response => {
          const list = (response.data && response.data.whitelist) || [];
          this.whitelistNames = list
            .map(item => item.allowedAccountName)
            .filter(Boolean);
          this.whitelistQueried = true;
        })
        .finally(() => {
          this.whitelistLoading = false;
        });
    },
    allocateSuccess() {
      this.$emit("allocateSuccess");
    },
    allocationAmount() {
      this.$emit("allocationAmount");
    },
    refreshCompany() {
      if (this.loadingAmount) return;
      this.$emit("refreshCompany");
    },
    refreshNoPay() {
      this.$emit("refreshNoPay");
    },
    copyAlipayAll() {
      let str = `
        账户名称:联帮帮物流科技(天津)有限责任公司
        银行账号:${this.alipayAccountNo}
        开户银行:浙江网商银行
      `;
      this.copyText(str);
    },
    copyAll() {
      let str = `
        账户名称:${this.currentCompany.branchName}
        开户银行:${this.currentCompany.openingBank}
        银行账户:${this.currentCompany.bankAccount}
        开户支行:${this.currentCompany.openingBranch}
        银联号:${this.currentCompany.subBankAccount}
      `;
      this.copyText(str);
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    }
  }
};
</script>
<style scoped lang="scss">
.tips_box {
  font-size: 13px;
  background: #f3f3f3;
  border-radius: 10px;
  padding: 10px;
  .m_r_20 {
    margin-left: 20px;
  }
}
.item_height {
  height: 720px;
}
.account_info_title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 5px;
  flex-wrap: wrap;

  .title_h2 {
    font-size: 20px;
    font-weight: bold;
    margin-right: 20px;
  }
}
.title_top_box {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  // border:1px solid;
}
.back-button {
  width: 79px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #409eff;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
  margin-left: -20px;
  margin-top: -3px;
  &:hover {
    background-color: #ecf5ff;
  }

  i {
    margin-right: 5px;
    font-size: 14px;
  }
}
.account_info_tips {
  color: #a3a3a3;
  flex: 1;
  display: flex;
  align-items: center;
}

.account_info_row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  // border-bottom: 1px dashed #ebeef5;
}

.m_b_0 {
  margin-bottom: 0px !important;
}

.account_info_label {
  width: 130px;
  color: #606266;
  font-weight: 600;
  margin-right: 15px;
  text-align: right;
  font-size: 15px;
}

.account_info_value {
  color: #303133;
  font-size: 15px;
  min-width: 200px;
}

.container_account_box {
  padding: 30px;
}
.container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 15px;
}

.account-card,
.record-card {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.company-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #2a6efd;
}

.balance-row {
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.balance-row > span {
  margin-right: 10px;
}

.highlight {
  font-size: 18px;
  color: #f56c6c;
  margin-right: 8px;
}

.bank-account {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.bank-account i {
  margin-left: 8px;
  color: #2a6efd;
}

.refresh_btn_box {
  display: flex;
  align-items: center;
}

.refresh_btn_text {
  margin-right: 3px;
  color: #2a6efd;
  cursor: pointer;
  &:hover {
    cursor: pointer;
  }
}
.refresh_icon {
  color: #2a6efd;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}

.help-tips {
  margin-top: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}

.help-tips p {
  margin: 5px 0;
}

/* 轮播相关样式 */
.record-carousel-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 180px;
}

.record-type-buttons {
  padding: 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  // justify-content: center;
}

.el-carousel {
  height: 720px;
  // border: 2px solid red;
}

.el-carousel__item {
  padding: 20px;
  // overflow-y: auto;
}

/* 确保轮播项内容不会溢出 */
.el-carousel__container {
  height: 100%;
}
.no_company_box {
  margin-top: 30px;
  margin-bottom: 190px;
}
.psw_icon {
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.copy_text {
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
  &:hover {
    opacity: 0.6;
  }
}
.all_copy {
  margin-left: 138px;
  margin-bottom: 15px;
}
.whitelist_list {
  margin-left: 145px;
  margin-top: 4px;
}
.whitelist_item {
  color: #303133;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 4px;
}
.whitelist_empty {
  margin-left: 145px;
  margin-top: 4px;
  color: #909399;
  font-size: 13px;
}
</style>
